  <template>
  <div v-if="visible && suggestions.length" class="suggestion-prompts">
    <div class="suggestion-grid">
      <button
        v-for="(suggestion, idx) in suggestions"
        :key="idx"
        class="suggestion-chip"
        @click="$emit('select', suggestion.text)"
      >
        <i v-if="suggestion.icon" :class="['fa', suggestion.icon, 'suggestion-chip__icon']" />
        <span class="suggestion-chip__text">{{ suggestion.text }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentSuggestionPrompts',

  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    suggestions: {
      type: Array,
      default: () => [],
      validator: (items) => items.every(({ text }) => typeof text === 'string'),
    },
  },
};
</script>

<style scoped>
.suggestion-prompts {
  width: 100%;
  padding: 0 0 16px;
}

.suggestion-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.suggestion-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f0f2f5;
  border: 1px solid #e0e4ea;
  border-radius: 14px;
  padding: 12px 14px;
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  color: #1a1a2e;
  line-height: 1.4;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
  white-space: normal;
  word-break: break-word;
}

.suggestion-chip:hover {
  background: #e6eaf2;
  border-color: #4a7dff;
  box-shadow: 0 2px 6px rgba(74, 125, 255, 0.12);
}

.suggestion-chip__icon {
  font-size: 16px;
  color: #495057;
  flex-shrink: 0;
}

.suggestion-chip__text {
  flex: 1;
  min-width: 0;
}
</style>
